import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import React from 'react'

function KeyDays(props: SvgIconProps) {
  return (
    <SvgIcon
      fill="none"
      height="128"
      viewBox="0 0 160 128"
      width="160"
      {...props}
    >
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_3266_21095"
          x1="114.291"
          x2="39.533"
          y1="96.6681"
          y2="2.91958"
        >
          <stop offset="0.00571742" stopColor="#F4F7FE" />
          <stop offset="0.9374" stopColor="white" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint1_linear_3266_21095"
          x1="40"
          x2="114"
          y1="40.75"
          y2="41.2289"
        >
          <stop stopColor="#EFF4FC" />
          <stop offset="1" stopColor="#BCCCEB" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint2_linear_3266_21095"
          x1="40"
          x2="114"
          y1="40.75"
          y2="41.2289"
        >
          <stop stopColor="#EFF4FC" />
          <stop offset="1" stopColor="#BCCCEB" />
        </linearGradient>
      </defs>
      <path
        d="M128.249 78.7758C96.5093 95.4072 103.602 116.478 69.4688 126.516C42.1052 134.568 13.2915 108.508 2.99825 80.9076C-1.68257 68.3639 -1.5323 47.2072 8.14113 31.3649C12.1532 24.7976 17.7958 19.1466 25.4106 15.3954C49.3631 3.59599 60.5204 17.5608 80.8478 15.545C87.4896 14.8868 95.1119 12.5194 104.481 6.9881C138.419 -13.0466 153.611 15.3954 157.882 25.022C163.149 36.885 160.433 61.9125 128.249 78.7758Z"
        fill="url(#paint0_linear_3266_21095)"
      />
      <path
        d="M85.3169 72.219L76.9996 67.2132L68.6823 72.199C67.1591 73.1164 65.2952 71.7603 65.6961 70.0452L67.9007 60.632L60.5454 54.2901C59.2026 53.1333 59.9241 50.9396 61.6877 50.8L71.3679 49.9823L75.1557 41.1076C75.8372 39.4922 78.162 39.4922 78.8434 41.1076L82.6313 50.0023L92.3114 50.8199C94.0751 50.9595 94.7966 53.1533 93.4538 54.31L86.0985 60.6519L88.3031 70.0651C88.7039 71.7802 86.84 73.1364 85.3169 72.219Z"
        fill="url(#paint1_linear_3266_21095)"
      />
      <path
        clipRule="evenodd"
        d="M102.9 14.3636H106.6C110.67 14.3636 114 17.6773 114 21.7273V80.6364C114 84.6864 110.67 88 106.6 88H47.4C43.33 88 40 84.6864 40 80.6364V21.7273C40 17.6773 43.33 14.3636 47.4 14.3636H51.1V10.6818C51.1 8.64841 52.7565 7 54.8 7C56.8435 7 58.5 8.64841 58.5 10.6818V14.3636H95.5V10.6818C95.5 8.64841 97.1565 7 99.2 7C101.243 7 102.9 8.64841 102.9 10.6818V14.3636ZM47.4 80.6364H106.6V32.7727H47.4V80.6364Z"
        fill="url(#paint2_linear_3266_21095)"
        fillRule="evenodd"
      />
    </SvgIcon>
  )
}

export default KeyDays
